module.exports = __webpack_public_path__ + "static/media/BMXX-BNB.db671b3a.svg";